import { render, staticRenderFns } from "./EntityEditForm.vue?vue&type=template&id=54a2f560&scoped=true"
import script from "./EntityEditForm.vue?vue&type=script&lang=js"
export * from "./EntityEditForm.vue?vue&type=script&lang=js"
import style0 from "./EntityEditForm.vue?vue&type=style&index=0&id=54a2f560&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54a2f560",
  null
  
)

export default component.exports